import styled, { css } from 'styled-components'
import { mediaDesktop } from '@components/styles/breakPoints'
import PageContainer from '@components/PageContainer'

// Page Container //

export const Main = styled.div`
  margin-top: 80px;
  min-height: calc(100vh - 80px);
  ${mediaDesktop} {
    padding-top: 0;
    background-size: initial;
  }
`

// Page 2 of Signup Form //

export const Step2Container = styled(PageContainer)`
  ${({ theme: { font, color } }) => css`
    > div {
      position: absolute;
      width: 100%;
      height: 100vh;
      transform: translateX(0%);
    }
    .title {
      margin-top: 34px;
      font-size: ${font.size.h4};
      font-weight: ${font.weight.normal};
      color: ${color.foreground.primary};
    }
    .subtitle {
      margin-top: 8px;
      color: ${color.foreground.secondary};
      font-size: ${font.size.body};
      font-weight: ${font.weight.normal};
    }

    .nameFields {
      display: flex;
      gap: 16px;
      > div {
        flex-grow: 1;
      }
    }

    .sms {
      margin: 24px 0 8px;
      font-weight: 600;
      input:checked + label {
        color: ${color.foreground.primary};
      }
      label {
        color: ${color.foreground.primary};
        font-size: ${font.size.body};
      }
    }
    .smsCaption {
      color: ${color.foreground.primary};
      font-size: ${font.size.caption};
      font-weight: ${font.weight.light};
      line-height: calc(1em + 8px);
      margin-left: 40px;
    }

    #tos {
      text-align: center;
      line-height: ${font.lineHeight};
      margin: 15px 32px 12px;
      color: ${color.foreground.primary};
      font-size: ${font.size.caption};
    }

    ${mediaDesktop} {
      .title {
        margin-top: 43px;
      }
    }
  `}
`
